import { Badge, Dropdown, Flex, Space, Tag, Typography } from "antd"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

import { titleSortFilters } from "../../../../../Components/titleSortFilters"
import Icon from "../../../../../Icon"
import {
  alertsColumnIconMap,
  dateFormat,
  statusTextMap,
  tagColorMap,
  tagMap
} from "../../../../../Utils/utils"

const { Text, Link } = Typography

dayjs.extend(utc)

export const getColumns = ({ options, handleChangeStatus }) => ({
  status: {
    key: "request_status",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Status",
        sorter: true,
        icon: alertsColumnIconMap["status"],
        stateData: state,
        key: "request_status"
      }),
    dataIndex: "request_status",
    width: 160,
    fixed: "left",
    render: (_, record) => {
      return (
        <Dropdown
          menu={{
            items: options
              ?.filter((el) => el !== _)
              .map((el) => ({
                key: el,
                label: (
                  <Flex gap={8} align="center">
                    <Badge status={tagMap[el?.toLowerCase()] || "default"} color={tagColorMap[el]} />
                    <Text>{statusTextMap[el] || el}</Text>
                  </Flex>
                )
              })),
            onClick: ({ key }) => handleChangeStatus({ id: record.id, newStatus: key })
          }}
        >
          <Tag
            color={tagMap[_?.toLowerCase()] || "default"}
            key={_}
            className={"simple large"}
            style={{ margin: 0 }}
          >
            <Flex gap={8} align="center">
              <Badge status={tagMap[_?.toLowerCase()] || "default"} color={tagColorMap[_]} />
              <Text>{statusTextMap[_] || _}</Text>
              <Icon type="chevron_down_small" style={{ marginLeft: -4 }} />
            </Flex>
          </Tag>
        </Dropdown>
      )
    }
  },
  user_full_name: {
    key: "user_full_name",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "User full name",
        sorter: true,
        icon: alertsColumnIconMap["user_full_name"],
        stateData: state,
        key: "user_full_name"
      }),
    dataIndex: "user_full_name"
    //width: 185,
  },
  user_email: {
    key: "user_email",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "User email",
        sorter: true,
        icon: alertsColumnIconMap["user_email"],
        stateData: state,
        key: "user_email"
      }),
    dataIndex: "user_email"
    //width: 185,
  },
  created_timestamp: {
    key: "created_timestamp",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Request date",
        sorter: true,
        icon: alertsColumnIconMap["created_timestamp"],
        stateData: state,
        key: "created_timestamp"
      }),
    dataIndex: "created_timestamp",
    width: 185,
    render: (_) => (
      <Space direction="vertical" size={4}>
        <Text>{dayjs(_).format(dateFormat)}</Text>
        <Text type="secondary">{dayjs(_).format("h:mm A [(UTC)]")}</Text>
      </Space>
    )
  },
  updated_timestamp: {
    key: "updated_timestamp",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Update status date",
        sorter: true,
        icon: alertsColumnIconMap["updated_timestamp"],
        stateData: state,
        key: "updated_timestamp"
      }),
    dataIndex: "updated_timestamp",
    width: 200,
    render: (_) =>
      _ ? (
        <Space direction="vertical" size={4}>
          <Text>{dayjs(_).format(dateFormat)}</Text>
          <Text type="secondary">{dayjs(_).format("h:mm A [(UTC)]")}</Text>
        </Space>
      ) : (
        "—"
      )
  },
  /*auto_refund_amount_other: {
      key: 'auto_refund_amount_other',
      title: (state) =>
        titleSortFilters({
          title: t('Auto-refund amount Ethoca&CDRN'),
          icon: alertsColumnIconMap['auto_refund_amount_other'],
          stateData: state,
          key: 'auto_refund_amount_other',
        }),
      dataIndex: 'auto_refund_amount_other',
      render: (_) => _ || '—'
    },
    auto_refund_amount_rdr: {
      key: 'auto_refund_amount_rdr',
      title: (state) =>
        titleSortFilters({
          title: t('Auto-refund amount RDR'),
          icon: alertsColumnIconMap['auto_refund_amount_rdr'],
          stateData: state,
          key: 'auto_refund_amount_rdr',
        }),
      dataIndex: 'auto_refund_amount_rdr',
      render: (_) => ('$' + formatNumber(_, 2, ','))
    },*/
  requested_amount: {
    key: "requested_amount",
    title: (state) =>
      titleSortFilters({
        title: "Requested amount",
        icon: alertsColumnIconMap["requested_amount"],
        stateData: state,
        key: "requested_amount"
      }),
    dataIndex: "requested_amount",
    width: 140,
    render: (_) => <Text style={{ color: "#16895A" }}>{_ ? `$ ${_}` : "—"}</Text>
  },
  current_amount: {
    key: "current_amount",
    title: (state) =>
      titleSortFilters({
        title: "Current amount",
        icon: alertsColumnIconMap["current_amount"],
        stateData: state,
        key: "current_amount"
      }),
    dataIndex: "current_amount",
    width: 110,
    render: (_) => (_ ? `$ ${_}` : "—")
  }
})

export const getDefaultColumn = ({ field_id, label }) => ({
  key: field_id,
  sorter: true,
  title: (state) =>
    titleSortFilters({
      title: label,
      sorter: true,
      icon: alertsColumnIconMap[field_id],
      stateData: state,
      key: field_id
    }),
  minWidth: 80,
  dataIndex: field_id,
  ellipsis: true
})
